import Comprobante from '@/models/Comprobante';
import TipoComprobante from '@/models/TipoComprobante';
import ValorCtacte from '@/models/ValorCtacte';
import Resumen from '@/models/Resumen';
import axios from 'axios';
function defaultState() {
	return {
		valoresdectasctes: [],
		resumenes: [],
		monedas: [],
		tableData: [],
		tipocomprobantes: [],
		tipoctasctes: [],
	};
}
const state = defaultState();
const getters = {};
const mutations = {
	setValoresDeCtasCtes(state: { valoresdectasctes: ValorCtacte[] }, valores: ValorCtacte[]) {
		state.valoresdectasctes = valores;
	},
	setResumenes(state: { resumenes: Resumen[] }, resumenes: Resumen[]) {
		state.resumenes = resumenes;
	},
	setMonedasDeMovimientos(state: { monedas: object[] }, monedas: object[]) {
		state.monedas = monedas;
	},
	setTableData(state: { tableData: Comprobante[] }, data: Comprobante[] | Comprobante) {
		!Array.isArray(data) ? state.tableData.push(data) : (state.tableData = []);
	},
	setTipoDeComprobantes(state: { tipocomprobantes: TipoComprobante[] }, tcomprobantes: TipoComprobante[]) {
		state.tipocomprobantes = tcomprobantes;
	},
	setTipoDeCtasCtes(state: { tipoctasctes: [] }, tctasctes: []) {
		state.tipoctasctes = tctasctes;
	},
};
const actions = {
	async callResumen({ commit }, params: { data: object; path: string; start: number; limit: number }): Promise<Comprobante[]> {
		let url;
		switch (params.path) {
			case '/1/cronologico':
				url = `./api/public/proxy/cgi/etenet_rencbtec?start=${params.start}&limit=${params.limit}`;
				break;
			case '/1/financiero':
				url = `./api/public/proxy/cgi/etenet_rencbtef?start=${params.start}&limit=${params.limit}`;
				break;
			case '/1/canje':
				url = `./api/public/proxy/cgi/etenet_rencbtej?start=${params.start}&limit=${params.limit}`;
				break;
		}
		const response = await axios.get(url, params.data);
		if (response.data.items) {
			response.data.items.forEach((element: Comprobante) => {
				//TODO: codigo necesario cuando se pase formato a tablas.
				//var dateParts = element.fecha.split('-');
				//element.fecha = dateParts[2] + '/' + dateParts[1] + '/' + dateParts[0];
				commit('setTableData', element);
			});
		}
		commit('setResumenes', response.data.resumenes as Resumen[]);
		commit('setValoresDeCtasCtes', (response.data.valoresdectasctes as ValorCtacte[]) ? (response.data.valoresdectasctes as ValorCtacte[]) : []);
		commit('setMonedasDeMovimientos', response.data.monedasdemovimientos);
		commit('setTipoDeComprobantes', response.data.tipodecomprobantes as TipoComprobante[]);
		commit('setTipoDeCtasCtes', response.data.tipodectasctes);
		return response.data.items;
	},
	async downloadFile({ commit, dispatch }, params: { recordSelected: any }): Promise<void> {
		var recordSelected = params.recordSelected;
		const response = await axios.get(
			`./api/public/proxy/files?codcom=${recordSelected.codcom}&codtal=${recordSelected.codtal}&numero=${recordSelected.numero}`
		);
		return response.data;
	},
	async dropFiles({ commit, dispatch }, params: { url: string; directorio: string }): Promise<void> {
		console.log('llama a drop files');
		axios.get(`/api/public/proxy/files?elimina=true&url=${params.url}&directorio=${params.directorio}`).then(response => {
			console.log('eliminados');
		});
	},
	async downloadFiles({ commit, dispatch }, params: { data: any; url: string }): Promise<void> {
		const response = await axios.get(params.url, params.data);
		return response.data;
	},
	reset(): void {
		Object.assign(state, defaultState());
	},
};
export default {
	state,
	getters,
	actions,
	mutations,
};
